import { useState, type FormEvent } from 'react'
import { ArrowLeft, Eye, EyeOff, LockKeyhole } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Brand } from '../layout/Brand'
import { useAdminTranslation } from './messages'

export function AdminLogin({ onLogin }: { onLogin: () => void }) {
  const { language, t } = useAdminTranslation()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [visible, setVisible] = useState(false)
  const [error, setError] = useState(false)
  function submit(event: FormEvent) {
    event.preventDefault()
    if (!username.trim() || !password.trim()) { setError(true); return }
    // Presentation-only session: credentials are never sent, logged or retained.
    setPassword('')
    onLogin()
  }
  return <div className="admin-login">
    <header className="admin-login__header"><Link to={`/${language}`} aria-label={t('backSite')}><Brand /></Link><Link to={`/${language}`}><ArrowLeft size={16} aria-hidden="true" />{t('backSite')}</Link></header>
    <main className="admin-login__main">
      <div className="admin-login__intro"><h1>{t('area')}</h1><p>{t('loginIntro')}</p></div>
      <div className="admin-login__card">
        <div className="admin-login__lock"><LockKeyhole size={24} aria-hidden="true" /></div>
        <form onSubmit={submit} noValidate>
          <label className="admin-field"><span>{t('username')}</span><input autoComplete="username" value={username} onChange={event => setUsername(event.target.value)} aria-invalid={error && !username.trim()} required /></label>
          <label className="admin-field"><span>{t('password')}</span><span className="admin-password"><input type={visible ? 'text' : 'password'} autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} aria-invalid={error && !password.trim()} required /><button type="button" aria-label={t(visible ? 'hidePassword' : 'showPassword')} onClick={() => setVisible(!visible)}>{visible ? <EyeOff size={18} /> : <Eye size={18} />}</button></span></label>
          {error ? <p className="admin-error" role="alert">{t('loginRequired')}</p> : null}
          <button className="admin-button admin-button--primary" type="submit">{t('signIn')}</button>
        </form>
      </div>
    </main>
    <footer className="admin-login__footer">{t('staff')}</footer>
  </div>
}
